import { createSlice } from '@reduxjs/toolkit';
const apiSlice = createSlice({
  name: 'apiResponses',
  initialState: {
    response: {},
    authenticated_user: {},
    trainingActive: 'NO',
    planActive: true,
    userType: 1,
  },
  reducers: {
    addApiResponse: (state, action) => {
      state.authenticated_user = action.payload.response;
      const authenticated_user = state.authenticated_user;
      if (authenticated_user?.authenticated_user) {
        const user = authenticated_user.authenticated_user;
        if (user.account_type == 'client' && user.override_disable_training_setting == 'YES') {
          state.trainingActive = 'YES';
        }
        if (user.user_type == '2' && user.plan_active != '1') {
          state.planActive = false;
          state.userType = 2;
        }
        if (user.user_type == '2' && user.plan_active == '1') {
          state.planActive = true;
          state.userType = 2;
        }
        if (user.user_type == '1') {
          state.planActive = true;
          state.userType = 1;
        }
      }
    },
  },
});
export const { addApiResponse } = apiSlice.actions;
export default apiSlice.reducer;